
import React, { useEffect, useState, Fragment } from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes';
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import {validationSchemasSolicitarInformeProfesional} from '../../common/validation-Schemas-Solicitar-Informe';
import {serviceGetTipoInforme, serviceGetGestores, serviceGetRequisitos, serviceGetImplicados, serviceGestionarInforme} from '../../api/api-solicitar-informe-profesional-ext.js';
import Requisitos from './requisitos.js';
import Mensajes from '../mensajes.js'
import {CarpetaDigitalComponent} from 'defcol-caso-general'

const IngresarSolicitudInforme = ({showModal, setShowModal, solicitudes, getSolicitudes}) => {
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    const { roles } = Auth.currentUser(); 

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});
    const [tieneSolVigentes, setTieneSolVigentes] = useState(false);

    const [tiposInforme, setTiposInforme] = useState([]);
    const [gestores, setGestores] = useState([]);
    const [implicados, setImplicados] = useState([]);
    const [implicadoSeleccionado, setImplicadoSeleccionado] = useState([]);
    const [stateTipoInforme, setStateTipoInforme] = useState("");
    const [stateImplicado, setStateImplicado] = useState("");
    const [stateGestor, setStateGestor] = useState("");
    const [observaciones, setObservaciones] = useState("");

    const[requisitos, setRequisitos]=useState([])
    const [esAnalistaCia, setEsAnalistaCia] = useState(false);

    const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
    const {llaves} = data_datos_generales

    const TIPO_INFORME_RAT = 299002;

     useEffect(() => {
        if (showModal) {
            getTipoInforme();
  
            if (roles && roles.length > 0) {
                let esAnalista = (roles?.filter((r) => (r .rol == '0070ANDEF0'))) ?.length > 0;
                setEsAnalistaCia(esAnalista);   
                console.log("esAnalista: ", esAnalista);  
            }
        }
    }, [showModal])

    const getTipoInforme = async () => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ concepto: 299 })).toString('base64');
        const response = await serviceGetTipoInforme(query);
        setTiposInforme(response);
        setLoading(false);
    }        
    function recargarRequisitos() {   
        if (llaves){
            getRequisitos();
        }
    }
    const getRequisitos = async () => {
        setLoading(true);   
        let query = Buffer.from(JSON.stringify({"idCaso":llaves && llaves['idCaso'], "codRequisito":"225030"})).toString('base64');
        setLoading(true);
        const response = await serviceGetRequisitos(query);
        setLoading(false);

        setRequisitos(response);
    }

    const handleTipoInforme = (value) => {
        setStateTipoInforme(value);    
        limpiarCambioTipoInforme();

        if (value == TIPO_INFORME_RAT) {//Informe RAT 
            getRequisitos();
            getGestores('70GESINFRAT');

            let solicitudesVig = (solicitudes?.filter((s) => (s.accionEstadoSolicitud == 1 && s.codTipoInforme == value)));//accion 1 es para estado en proceso
            setTieneSolVigentes(solicitudesVig.length > 0);
        } else {
            getGestores('70GESINFMED');
            getImplicados();
        }
    }
    const getGestores= async (rol) => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idOrganizacion: llaves && llaves['idOrgCaso'], rol: rol, tipoPersona: '0080PROVE00' })).toString('base64');
        const response = await serviceGetGestores(query);
        setGestores(response);
        setLoading(false);
    }
    const getImplicados = async () => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({
            idOrgCaso:llaves && llaves["idOrgCaso"],
            idCaso: llaves && llaves["idCaso"]
        })).toString('base64')
        const response = await serviceGetImplicados(query);
        setImplicados(response);
        setLoading(false);
    }  
    const handleGestor = (value) => {
        setStateGestor(value);
    }
    const handleImplicado = (value) => {
        const implSelect = implicados.filter(item => item.IdImplicado == value);
        setStateImplicado(value);

        setImplicadoSeleccionado(implSelect[0]);
        
        if (value != "") {
            let solicitudesVig = (solicitudes?.filter((s) => (s.accionEstadoSolicitud == 1 && s.idImplicado == implSelect[0].IdImplicado && s.codTipoInforme == stateTipoInforme)));//accion 1 es para estado en proceso
            setTieneSolVigentes(solicitudesVig.length > 0);
        }
    }
    const handleClose = () => {
        setShowModal(false);
    }
    const handleCloseToast = () => {
        setShowToast(false);
        getSolicitudes();
        
        handleLimpiar();
    }
    const handleLimpiar = () => {
        formik.resetForm();   
        setStateTipoInforme("");
        limpiarCambioTipoInforme();
    }
    const limpiarCambioTipoInforme = () => {
        setObservaciones("");
        setImplicadoSeleccionado(null);
        setTieneSolVigentes(false);
        setStateImplicado("");
        setStateGestor("");
    }
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": "",
            "tipoInforme": "",
            "gestor":"",
            "observaciones": "",
        },
        validationSchema: validationSchemasSolicitarInformeProfesional(esAnalistaCia, stateTipoInforme),
        onSubmit: (formData) => {

            const hayFaltantes = requisitos.some(item => item.reqObligatorio === 1 && (item.folioCarga === 0 || item.folioCarga === null));

            if (stateTipoInforme == TIPO_INFORME_RAT && hayFaltantes) {
                formik.setErrors({valRequisitos: `Faltan documentos que son obligatorios.`});
                return;
            }
            const dataForm = {
                ...formData
            }
            dataForm['idCaso'] = llaves && llaves['idCaso'];
            dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso'];          
            dataForm['accion'] = 1;
            dataForm['implicado'] = implicadoSeleccionado;
            
            setLoading(true);            

            console.log("dataForm:", dataForm);
            
            try {
                serviceGestionarInforme(dataForm)
                .then((response) => {
                                                
                    setRespuestaGestion(response);
                    handleShowToast(true);
                    setLoading(false);                           
                })
                .catch((error) => {
                    setLoading(false);
                    console.error(error.message);
                    alert(error.message);
                });   
            } catch (error) {
                setLoading(false);
                console.error("error: ", error);
            }
        }
    })
    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta= () => setShowCarpeta(false)

    return (
        <Fragment>

            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
                    idCaso={llaves && llaves['idCaso']}
                    idImplicado={llaves && llaves['idImplicado']}
                    idOrganizacionCaso={llaves && llaves['idOrgCaso']}
                    prototipo={2}            
                />   
            </Modal>

            <LoadingComponent show={loading} />
            <Form onSubmit={formik.handleSubmit}>
                <Card >
                    <Card.Header className='cardHeader'>
                        {(cfg_form && cfg_form["solicita-informe-titleing"]) ? cfg_form["solicita-informe-titleing"] : 'Solicitud Informe Profesional'} - ID Caso {llaves && llaves['idCaso']    }
                    </Card.Header>
                    <Card.Body className='customCard'>

                        <Row className='containerHeader'>
                            <Col md='3'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["solicita-informe-cmb-tipoinf"]) ? cfg_form["solicita-informe-cmb-tipoinf"] : 'Tipo Informe'}
                                </Form.Label>
                                <Form.Select
                                    name='tipoInforme'
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        handleTipoInforme(e.target.value)
                                      }
                                    }
                                    value={stateTipoInforme}>
                                    <option value={""}>Seleccione</option>
                                    {tiposInforme && tiposInforme
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                                {formik.errors.tipoInforme ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.tipoInforme}
                                </Form.Text>
                                ) : (
                                ''
                                )}
                            </Col>
                            {esAnalistaCia &&

                            <Col md='6'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["solicita-informe-cmb-gestores"]) ? cfg_form["solicita-informe-cmb-gestores"] : 'Gestor Informe Profesional'}
                                </Form.Label>
                                <Form.Select
                                    name='gestor'
                                    value={formik.values.gestor=stateGestor}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                        handleGestor(e.target.value)
                                      }
                                    }>
                                    <option value={""}>Seleccione</option>
                                    {gestores && gestores
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                                {formik.errors.gestor ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.gestor}
                                </Form.Text>
                                ) : (
                                ''
                                )}
                            </Col>
                            }
                            <Col md='3'></Col>
                        </Row>
                        <Row>
                            <Col md="7" >
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["solicita-informe-text-coment"]) ? cfg_form["solicita-informe-text-coment"] : 'Comentario'}
                                </Form.Label>
                                <br />
                                <Form.Control as="textarea" rows={3} 
                                    onChange={e=>{                    
                                        formik.handleChange(e)
                                        setObservaciones(e.target.value)                                    
                                    }}
                                    name='observaciones'                            
                                    value={formik.values.observaciones=observaciones}
                                    error={formik.errors.observaciones}  
                                />
                                {formik.errors.observaciones ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.observaciones}
                                </Form.Text>
                                ) : (
                                ''
                                )}
                            </Col>
                            {stateTipoInforme && stateTipoInforme == TIPO_INFORME_RAT &&
                                <Col md="5" >
                                    <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>Documentos Requridos</Form.Label>
                                    <Requisitos 
                                        requisitos={requisitos && requisitos} 
                                        recargarRequisitos={recargarRequisitos}
                                    />           
                                    {formik.errors.valRequisitos ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.valRequisitos}
                                    </Form.Text>
                                    ) : (
                                    ''
                                    )}     
                                </Col>
                            }
                            {stateTipoInforme && stateTipoInforme != TIPO_INFORME_RAT &&
                                <Col md='5'>
                                    <Row>
                                        <Col>
                                            <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                {(cfg_form && cfg_form["solicita-informe-cmb-implicados"]) ? cfg_form["solicita-informe-cmb-implicados"] : 'Seleccione Implicado'}
                                            </Form.Label>
                                            <Form.Select
                                                name='implicado'
                                                value={formik.values.implicado=stateImplicado}
                                                onChange={(e) => {
                                                    formik.handleChange(e)
                                                    handleImplicado(e.target.value)
                                                }
                                                }>
                                                <option value={""}>Seleccione</option>
                                                {implicados && implicados
                                                    .map((i, index) => (<option key={index} value={i.IdImplicado}>{i.NombreImplicado}</option>))
                                                }
                                            </Form.Select>
                                            {formik.errors.implicado ? (
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.implicado}
                                            </Form.Text>
                                            ) : (
                                            ''
                                            )}
                                        </Col>                            
                                    </Row>
                                    <br />
                                    <Row>
                                        <Col md='3'>
                                            <Form.Text className='mb-3'>
                                                {implicadoSeleccionado ? implicadoSeleccionado['RutImplicado'] : null}
                                            </Form.Text>
                                        </Col>
                                        <Col md='9'>
                                            <Form.Text className='mb-3'>
                                                {implicadoSeleccionado ? implicadoSeleccionado['NombreImplicado'] : null}
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                        <Row>
                            <Col md="7" ></Col>
                            
                        </Row>


                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>
                        
                        <Row className='containerHeader'>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                    {(cfg_form && cfg_form["solicita-informe-btncerrar"]) ? cfg_form["solicita-informe-btncerrar"] : 'Cerrar'}
                                </Button>
                                <Button style={{ width: '110px', marginRight: '5px', color:'#ffffff' }} variant='btn btn-info' onClick={handleLimpiar}>
                                    {(cfg_form && cfg_form["solicita-informe-btnlimpiar"]) ? cfg_form["solicita-informe-btncerrar"] : 'Limpiar'}
                                </Button>
                                <Button style={{ width: '130px', marginRight: '5px' }} variant='carpeta' onClick={handleShowCarpeta}>
                                    {(cfg_form && cfg_form["solicita-informe-btncarpeta"]) ? cfg_form["solicita-informe-btncarpeta"] : 'Documentos'}
                                </Button>
                                <Button disabled={tieneSolVigentes} style={{ width: '110px', color: 'white' }} variant="" className="btn-solicitar" type='onSubmit'>
                                    {(cfg_form && cfg_form["solicita-informe-btnsolicitar"]) ? cfg_form["solicita-informe-btnsolicitar"] : 'Solicitar'}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Container>
                    <Row>
                        <Col>
                            {respuestaGestion && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaGestion}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>            
            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .containerHeader {
                        display: flex;
                        justify-content: space-between;
                    }
                    .customCard {
                        padding-top: 0;
                        padding-left: 0;
                        padding-right: 0;
                        padding: 1rem;
                    }
                    .customHeaderCard {
                        background-color: #676999;
                        color: #fff;
                        font-size: 17px;
                        font-weight: 600;
                        text-align: center;
                        text-decoration: underline;
                    }
                    .cursor {
                        cursor: pointer;
                    }
                    .btn-carpeta {
                        background-color: #F0AD3E;
                        color: #FFFFFF;
                        width: 140px;                    
                    }
                    .btn-carpeta:hover{
                        background-color:#e1b97f;
                        color: #FFFFFF;
                    }
                    .btn-solicitar {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        width: 140px;
                        padding: 6px 0px;
                    }
                    .btn-solicitar:hover {
                        background-color: #F6897E;
                        color: #FFFFFF;
                    }
                    .btn-solicitar:disabled {
                        background-color: #C14B49;
                        color: #FFFFFF;
                        opacity: 0.65;
                        cursor: not-allowed;
                    }
                    .btn-solicitar:disabled:hover {
                        background-color: #C14B49;
                        color: #FFFFFF;
                    }
                    .btn-solicitar:focus {
                        outline: none;
                        box-shadow: none;
                    }
                `}
            </style>
        </Fragment>
        )
}
export default IngresarSolicitudInforme
